import * as yup from "yup";

export const schema = yup.object({
  ctOffer: yup.string().required("dfsdfsd"),
  priceOffer: yup.string().required("dfsdfsd"),
  memoComments: yup.string().required(),
  itemId: yup.string().optional(),
  payWithIn: yup.number().required(),
  buyComments: yup.string().required(),
  holdComments: yup.string().required(),
  hold_hours: yup.string().required(),
});
